// extracted by mini-css-extract-plugin
module.exports = {"container":"ContactView_container__Wnidi","name":"ContactView_name__1wZwj"};